(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mb-content-switch"] && !Shopify.designMode) return;
  try {
    
(function() {

  if (window.MBContentSwitchLoaded) { return; }
  window.MBContentSwitchLoaded = true;

  class MBContentSwitch extends HTMLElement {
    constructor() {
      super();
      console.log('MBContentSwitch component initialized');
      this.tabs = this.querySelectorAll('.MBContentSwitch__tab');
      this.content = this.querySelector('.MBContentSwitch__content');
      this.cache = {};
      this.initTabs();
    }

    initTabs() {
      this.tabs.forEach(tab => {
        tab.addEventListener('click', (event) => {
          event.preventDefault();
          this.activateTab(tab);
        });
      });
      // Activate the first tab by default
      if (this.tabs.length > 0) {
        this.activateTab(this.tabs[0]);
      }
    }

    activateTab(tab) {
      const tabId = tab.dataset.tab;

      // Deactivate all tabs
      this.tabs.forEach(t => t.classList.remove('active'));

      // Hide all content
      this.content.innerHTML = '';

      // Activate the clicked tab
      tab.classList.add('active');

      // Check if the content is already cached 
      if (this.cache[tabId]) {
        console.log(`Content for tab ${tabId} is cached.`);
        this.content.innerHTML = this.cache[tabId];
        if (_observeVisibleVideo) { _observeVisibleVideo(); }
        return;
      }

      // Get the tab url and load content
      const url = tab.querySelector('a').getAttribute('href');
      if (url && url !== '#') {
        this.loadContentFromUrl(url, tab);
      } 
    }

    loadContentFromUrl(url, tab) {
      const tabId = tab.dataset.tab;
      const selector = tab.dataset.selector || '';
      const excluder = tab.dataset.excluder || '';

      // Simulate an AJAX request to fetch content
      this.setAttribute("loading", "true");

      // load the html content from the url using fetch
      fetch(url)
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.text();
      })
      .then(html => {
        this.removeAttribute("loading");
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const contentElements = selector ? doc.querySelectorAll(selector) : Array.from(doc.body.children);
        if (contentElements.length > 0) {
          this.content.innerHTML = '';
          contentElements.forEach(element => {
            if (excluder && new RegExp(excluder).test(element.id)) { return;}
            this.content.appendChild(element);
          });
          this.cache[tabId] = this.content.innerHTML; 
          if (_observeVisibleVideo) { _observeVisibleVideo(); }
        } else {
          this.content.innerHTML = `<p>No content found in the loaded HTML from ${url}.</p>`;
        }
      })
      .catch(error => {
        console.error('Error loading content:', error);
        this.content.innerHTML = `Oops! Something went wrong. Please try again.`;
        this.removeAttribute("loading");
      });
    }

  }
  customElements.define('mb-content-switch', MBContentSwitch);

})();

  } catch(e) { console.error(e); }
})();
})();
